import { render } from "./Providers.vue?vue&type=template&id=c69a9968&scoped=true&ts=true"
import script from "./Providers.vue?vue&type=script&lang=ts"
export * from "./Providers.vue?vue&type=script&lang=ts"

import "./Providers.vue?vue&type=style&index=0&id=c69a9968&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c69a9968"]])

export default __exports__